import React, { forwardRef, type Ref } from "react";
import styled from "styled-components";
import * as RadixPopover from "@radix-ui/react-popover";


import { cn } from "@/utils/helpers/classnames";
import { XCircleIcon } from "lucide-react";

interface PopoverProps {
  trigger?: React.ReactNode;
  closeIcon?: React.ReactNode;
  alignOffset?: number;
  showCloseIcon?: boolean;
  showArrow?: boolean;
  arrowIcon?: React.ReactNode;
  children: React.ReactNode;
  sideOffset?: number;
  align?: "center" | "start" | "end";
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
  defaultOpen?: boolean;
  contentClassName?: string;
  collisionPadding?: number;
  side?: "top" | "right" | "bottom" | "left";
}

const Popover = forwardRef(({ trigger = <DefaultTriggerBtn>
      Trigger
    </DefaultTriggerBtn>, children, closeIcon, showCloseIcon, alignOffset, sideOffset = 8, showArrow, arrowIcon, onOpenChange, align, open, defaultOpen, contentClassName, collisionPadding = 16, side }: PopoverProps, ref: Ref<HTMLDivElement>) => {
  return (
    <div ref={ref} className=''>
      <RadixPopover.Root onOpenChange={onOpenChange} open={open} defaultOpen={defaultOpen}>
        <StyledTrigger asChild>
         {trigger}
          {/* {trigger} */}
        </StyledTrigger>
        <StyledPortal>
          <StyledContent
            style={{
              zIndex: "1000"
              // maxHeight: "var(--radix-popover-content-available-hight)",
              // minHeight: "var(--radix-popover-trigger-height)",
            }}
            sideOffset={sideOffset}
            align={align}
            alignOffset={alignOffset}
            avoidCollisions
            collisionPadding={collisionPadding}
            side={side}
            className={cn(
              "overflow-y-auto rounded-[1rem] border border-light700 bg-white shadow-equal",
              contentClassName
            )}
          >
            {showCloseIcon ? <StyledClose>{closeIcon ? closeIcon : <XCircleIcon />}</StyledClose> : null}
            {showArrow ? arrowIcon ? arrowIcon : <StyledArrow /> : null}
            {children}
          </StyledContent>
        </StyledPortal>
      </RadixPopover.Root>
    </div>
  );
});

Popover.displayName = "Popover";

export default Popover;

const StyledPortal = styled(RadixPopover.Portal)`
  width: 100%;
`;

const StyledTrigger = styled(RadixPopover.Trigger)`
  cursor: pointer;
  display: inline-flex;
`;

const DefaultTriggerBtn = styled.div`
  padding: 0.125rem 0.5rem;
  border-radius: 0.25rem;
  background-color: #000;
  border: 1px solid #000;
  color: white;
  font-size: 0.875rem;
  outline: none;
`;

const StyledClose = styled(RadixPopover.Close)`
  position: relative;
  align-self: flex-end;
  cursor: pointer;
  background: none;
  border: none;
`;

const StyledContent = styled(RadixPopover.Content)`
  display: flex;
  flex-direction: column;
  max-height: calc(var(--radix-popover-content-available-height, auto) - 1rem);
`;

const StyledArrow = styled(RadixPopover.Arrow)`
  fill: black;
`;
